import { useState, useEffect } from "react";

import { GetRecommendedSiteNameResponse } from "@atlassiansox/asc-stargate";

import { useBxpWebStargateClient } from "@/libraries/bxp-web-stargate-client/src/hook";
import { useLoggedInUser } from "@/utils/logged-in-user-provider";

import { useSiteActivationContext } from "../hooks/site-activation-context";

export interface UseRecommendedSiteNameProps {
    onError?: (error: unknown) => void;
}

export function useRecommendedSiteName(
    props: UseRecommendedSiteNameProps = {}
) {
    const { siteName, setSiteNameValue, recommendedSiteName } =
        useSiteActivationContext();

    const [siteNamePopulated, setSiteNamePopulated] = useState<boolean>();

    const client = useBxpWebStargateClient();
    const user = useLoggedInUser();
    const email = user?.email;

    useEffect(() => {
        if (email) {
            client
                .getRecommendedSiteName({
                    email
                })
                .then((result: GetRecommendedSiteNameResponse) =>
                    setSiteNameValue(result.recommendedName)
                )
                .catch(props.onError);
        }
    }, [client, email, props.onError, setSiteNameValue]);

    useEffect(() => {
        if (siteNamePopulated) {
            // take no action because site name was already changed via either user interaction or site-name recommendation
            return;
        }
        if (siteName) {
            // user has already started typing, let's not overwrite their input with a recommended site name
            setSiteNamePopulated(true);
        } else if (recommendedSiteName) {
            setSiteNameValue(recommendedSiteName);
            setSiteNamePopulated(true);
        }
    }, [siteNamePopulated, recommendedSiteName, siteName, setSiteNameValue]);
}
